import { useCallback, useEffect } from "react";
import type { PaginationState } from "@tanstack/react-table";
import type { FilterValues } from "../../../../datagrid-configs/types";
import type { useDiscoverGamesBatchActions } from "./useDiscoverGamesBatchActions";
import type { useDiscoverGamesFilters } from "./useDiscoverGamesFilters";
import type { useDiscoverGamesQuery } from "./useDiscoverGamesQuery";

type Filters = ReturnType<typeof useDiscoverGamesFilters>;
type Query = ReturnType<typeof useDiscoverGamesQuery>;
type Batch = ReturnType<typeof useDiscoverGamesBatchActions>;

export function useDiscoverGamesFilterHandlers(filters: Filters, query: Query, batch: Batch) {
	const handleFilterChange = useCallback(
		(values: FilterValues) => {
			filters.handleFilterChange(values);
			query.setPagination((prev: PaginationState) => ({ ...prev, pageIndex: 0 }));
		},
		[filters, query],
	);

	const handleClearFilters = useCallback(() => {
		filters.handleClearFilters();
		query.setPagination((prev: PaginationState) => ({ ...prev, pageIndex: 0 }));
	}, [filters, query]);

	useEffect(() => {
		batch.clearBulkOnQueryChange();
	}, [query.queryChangeSignature, batch.clearBulkOnQueryChange]);

	return { handleFilterChange, handleClearFilters };
}
